import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HeaderComponent } from './shared/layout/header/header.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';


export const routes: Routes = [
 {
   path: '',
   component: HeaderComponent,
   children:[
     {
       path: '',
       loadChildren:'./main/main.module#MainModule'

     },
    //  {
    //   path: '**',
    //   component: ErrorpageComponent ,
    // }   
   ]
 },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
